import { GeneralModel } from "./general.model";

export class ModulePage extends GeneralModel {
    url: string;
    backColor: string;
    icon: string;
}